import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { N0DES_API_PREFIX } from "@/api/domain"
import type { GithubRepoInfo } from "@/github"
import type { Repo } from "@/repos"
import type { ProjectIdParam, Uuid } from "@/types"

type DeleteRepoParams = ProjectIdParam & {
  repo_id: Uuid
}

// Define a service using a base URL and expected endpoints
export const reposApi = createApi({
  reducerPath: "repos",
  baseQuery: fetchBaseQuery({
    baseUrl: `${N0DES_API_PREFIX}repos`,
    mode: "cors",
    credentials: "include",
  }),
  tagTypes: ["Repo"],
  endpoints: (build) => ({
    repoGet: build.query<Repo, ProjectIdParam>({
      query: (body) => ({
        url: `${body.project_id}`,
      }),
    }),
    repoGetReadme: build.query<string, ProjectIdParam>({
      query: (body) => ({
        url: `${body.project_id}/readme`,
        responseHandler: "text",
      }),
    }),
    repoGetStats: build.query<GithubRepoInfo, ProjectIdParam>({
      query: (body) => ({
        url: `${body.project_id}/stats`,
      }),
      providesTags: (_, __, arg) => [{ type: "Repo", id: arg.project_id }],
    }),
    repoDelete: build.mutation<void, DeleteRepoParams>({
      query: ({ project_id, repo_id }) => ({
        url: `${project_id}/${repo_id}`,
        method: "DELETE",
      }),
    }),
  }),
})

export const {
  useRepoGetQuery,
  useRepoGetReadmeQuery,
  useRepoGetStatsQuery,
  useRepoDeleteMutation,
} = reposApi
